import React from 'react';
import './css/EditCreate.css';

//Shows "Edit X" if user is editting and "View X" if no button was toggled
class CardTitle extends React.Component {

    render() {
        if (!this.props.readOnly) {
            return <div className="align-items-center card-header d-flex justify-content-center"> <div>Edit {this.props.component}</div></div>
        } else {
            return <div className="align-items-center card-header d-flex justify-content-center"> <div>View {this.props.component}</div></div>
        }
    }
}

export default CardTitle;